import React, { Fragment,useEffect, useRef, useState } from 'react'
import { KTSVG } from '../../../_metronic/helpers'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { expensePolicyLockingExpenseInitialsForUpdate } from './interfaces/expensePolicyLockingExpenseClass';
import { updateLockingExpensesByAccountExpensePolicyIdAsync } from './expensePolicyLockingExpensesSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import { Formik } from 'formik';
import { ShowToast } from '../../../common/Toastr';
import { resetSelectedRecordObjectInState } from '../expensePolicy/expensePolicySlice';
import { getValueFromResource } from '../../../common/timeLiveFunction';
const ExpensePolicyLockingExpensesForm = (props: any) => {
    const { modelRef, t, oncloseModal} = props;
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(expensePolicyLockingExpenseInitialsForUpdate);
    const { selectedRecord,isLoading } = useAppSelector((state) => state.expensePolicyLockingExpenses);
    const { MasterExpensePolicyId } = useAppSelector((state) => state.expensePolicy);
    const dispatch = useAppDispatch();
     const navigate = useNavigate();  
    const location = useLocation();
    const { obj } = location.state || {};
    const storedObjectData = localStorage.getItem('objExpensePolicyItem');
    const objectData = storedObjectData ? JSON.parse(storedObjectData) : null;
    let AccountExpensePolicyId = '00000000-0000-0000-0000-000000000000';
    if (MasterExpensePolicyId && MasterExpensePolicyId !== '') {
        AccountExpensePolicyId = MasterExpensePolicyId;
    } else if (obj && obj.AccountExpensePolicyId) {
        AccountExpensePolicyId = obj.AccountExpensePolicyId;
    } else if (objectData && objectData.AccountExpensePolicyId) {
        AccountExpensePolicyId = objectData.AccountExpensePolicyId;
    } else {
        navigate('../expensepolicy');
    }



    useEffect(() => {
        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            Object.keys(expensePolicyLockingExpenseInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })
            stateItem.LockAllPreviousExpenseEntries = stateItem.LockAllPreviousExpenseEntries === true ? true : false;
            stateItem.LockAllPreviousMonthsExpenseEntries = stateItem.LockAllPreviousMonthsExpenseEntries === true ? true : false;
            setCurrentFieldsData(stateItem);
        }       
    }, [selectedRecord])

      const handleSubmit = (values: any) => {
        if (Object.keys(selectedRecord).length > 0) {
            dispatch(updateLockingExpensesByAccountExpensePolicyIdAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    ShowToast('Locking Expense Entries Update Successfully', 'Success', "success", "toast-top-right") 
                })
                .catch((rejectedValueOrSerializedError) => {
                    console.log('handleSubmitGeneral-updateLockingExpensesByAccountExpensePolicyIdAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
                })
        }   
        oncloseModal();    
    }

    const handleCloseOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
    }

    return (
        <>
        <Formik
        initialValues={{
            ...currentFieldsData,  AccountExpensePolicyId: AccountExpensePolicyId,
            
        }}
        enableReinitialize={true}
        onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
        validationSchema={yup.object().shape({
           
        })}>
        {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                <Fragment>
                    <form>
                        <div className='card-body'>
                            {isLoading ?
                                <div className="col-md-12">
                                    <span className='indicator-progress' style={{ display: 'block' }}>
                                        <span className='spinner-border spinner-border-md ms-2'></span>
                                    </span>
                                </div>
                                : <>
                                    <div className="modal drawer-overlay" style={{ display: 'block' }}
                                    >
                                        <div className="modal-dialog">
                                            <div className="modal-content">
                                                <div className="modal-header" style={{ padding: '.6rem .6rem' }}>
                                                    <h5 className="modal-title mainHeading">
                                                        {/* {t('Update Locking Expense Entries')} */}
                                                        {getValueFromResource('Update Locking Expense Entries',dispatch, t)}
                                                         </h5>
                                                    <div
                                                        className="btn btn-icon btn-sm btn-active-secondary ms-2 "
                                                        onClick={oncloseModal}
                                                    >
                                                        <KTSVG
                                                            path="/media/icons/duotune/arrows/arr061.svg"
                                                            className="svg-icon svg-icon-1x"
                                                        />
                                                    </div>
                                                </div>
                                                    <div className="modal-body">
                                                        <form className='form'>
                                                            <div className='row'>
                                                            {Object.keys(selectedRecord).length > 0 ? (
                                                            <div className="mb-3">
                                                                <label className="fs-7 fs-7 fw-normal">
                                                                    {/* {t('Lock All Previous Expense Entries')} */}
                                                                    {getValueFromResource('Lock All Previous Expense Entries',dispatch, t)}

                                                                    </label>
                                                                <div className="form-check form-switch form-check-custom form-check-solid">
                                                                <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.LockAllPreviousExpenseEntries} id="LockAllPreviousExpenseEntries"  onChange={handleChange('LockAllPreviousExpenseEntries')} />
                                                            </div>                                                      
                                                            </div>
                                                              ) : null}
                                                               {Object.keys(selectedRecord).length > 0 ? (
                                                            <div className="mb-3">
                                                                <label className="fs-7 fs-7 fw-normal">
                                                                    {/* {t('Lock All Previous Months Expense Entries')} */}
                                                                    {getValueFromResource('Lock All Previous Months Expense Entries',dispatch, t)}

                                                                    </label>
                                                                <div className="form-check form-switch form-check-custom form-check-solid">
                                                                <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.LockAllPreviousMonthsExpenseEntries} id="LockAllPreviousMonthsExpenseEntries"  onChange={handleChange('LockAllPreviousMonthsExpenseEntries')} />
                                                            </div>                                                      
                                                            </div>
                                                              ) : null}
                                                            </div>
                                                        </form>
                                                    </div>
                                                <div className="modal-footer" style={{ padding: '.6rem .6rem' }} >
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary btn-bs-btn-font-weight btn-sm"
                                                        onClick={oncloseModal}
                                                    >
                                                        {/* {t('Cancel')} */}
                                                        {getValueFromResource('Cancel',dispatch, t)}

                                                    </button>
                                                    <button type="button" className="btn btn-primary  btn-bs-btn-font-weight btn-sm" onClick={() => handleSubmit()} disabled={!isValid}>
                                                    {/* {t('Save')}   */}
                                                    {getValueFromResource('Save',dispatch, t)}

                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                    </form>
                </Fragment>
            )}
        </Formik>
    </>     
    )
}

export default ExpensePolicyLockingExpensesForm